






























import { Component, Vue } from "vue-property-decorator";
import { deleteStage, checkDelete } from "@/services/stages/stageService";

@Component
export default class StageDeleteModal extends Vue {
    stageToBeDeleted: string = "";
    stageName: string = ""

    handleEnter(e: KeyboardEvent) {
        if (e.key === "Enter") {
            if (this.stageToBeDeleted !== "") this.confirm();
            else this.close();
        }
    }

    removeEvent() {
        window.removeEventListener("keydown", this.handleEnter);
        this.stageToBeDeleted = "";
        this.stageName = "";
    }

    open(stageId: string, name: string) {
        checkDelete(stageId).then(response => {
            console.log(response);
            if (response) {
                this.stageToBeDeleted = stageId;
                this.stageName = name;
                this.$bvModal.show("modal-deleteStage");
            } else {
                this.$bvModal.show("modal-deleteStageNotAllowed");
            }

            window.addEventListener("keydown", this.handleEnter);
        });
    }

    close() {
        this.$bvModal.hide("modal-deleteStageNotAllowed");
    }

    decline() {
        this.$bvModal.hide("modal-deleteStage");
        this.stageToBeDeleted = "";
        this.stageName = "";
    }

    confirm() {
        deleteStage(this.stageToBeDeleted).then(() => {
            this.$emit("reload");
            this.$bvModal.hide("modal-deleteStage");
            this.stageToBeDeleted = "";
            this.stageName = "";
        });
    }
}
